// extracted by mini-css-extract-plugin
export default {"font-renta":"FormSummarySignatureTableRow_font-renta__g+G4o","formSummarySignatureTableRow":"FormSummarySignatureTableRow_formSummarySignatureTableRow__EmAQT"};